<template>

  <b-modal
    :id="'add-facture-modal-' + this.operationConstruction.id"
    :cancel-title="$t(cancelTitle)"
    :cancel-variant="this.cancelVariant"
    :ok-title="$t(okTitle)"
    :title="$t(okTitle) + ' ' + $t('facture') + ' : ' + operationConstructionName"
    centered
    ok-variant="primary"
    @cancel="handleAddAndValidate"
    @ok="handleAdd">

    <div class="row">
      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.Name')"
          class="medium-label mb-4"
          label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="nom"
            required
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.Libelle')"
          class="medium-label mb-4"
          label-for="libelle-input">
          <b-form-input
            id="libelle-input"
            v-model="libelle"
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.issued.date')"
          class="medium-label mb-4"
          label-for="issuedDate-input">
          <datepicker-input
            id="issuedDate-input"
            v-model="issuedDate">
          </datepicker-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.Status')"
          class="medium-label mb-4"
          label-for="status-input">
          <b-form-select
            id="status-input"
            v-model="status"
            required
            @change="paidDate=null">
            <option v-for="option in statusFactureList" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>


      <div v-if="status==='PAID'" class="col-md-6">
        <b-form-group
          :label="$t('facture.paid.date')"
          class="medium-label mb-4"
          label-for="paidDate-input">
          <datepicker-input
            id="paidDate-input"
            v-model="paidDate">
          </datepicker-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('devis.PrixTTC')"
          class="medium-label mb-4"
          label-for="prixTTC-input">
          <b-input-group>
            <b-form-input
              id="prixTTC-input"
              v-model="prixTTC"
              v-disable-scroll
              min="0"
              required
              step="any"
              type="number">
            </b-form-input>
            <b-input-group-append>{{ '€' }}</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.PrixTVA')"
          class="medium-label mb-4"
          label-for="prixTVA-input">
          <b-input-group>
            <b-form-input
              id="prixTVA-input"
              v-model="tauxTVA"
              v-disable-scroll
              min="0"
              required
              step="any"
              type="number">
            </b-form-input>
            <b-input-group-append>{{ '€' }}</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>


      <div class="col-md-6">
        <b-form-group
          :label="$t('facture.bank.statement')"
          class="medium-label mb-4"
          label-for="statement-input">
          <b-form-input
            id="statement-input"
            v-model="compte"
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-12">
        <multi-file-field
          :label="$t('Documents').toString()"
          :new-files-list="newDocumentsList"
          :old-files-list="oldDocumentsList"
          @addFiles="addDocuments"
          @removeNewFile="removeNewDocument"
          @removeOldFile="removeOldDocument"/>
      </div>


    </div>

  </b-modal>

</template>

<script>

import api from "../../../services/api";
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField.vue";
import MultiFileField from "../../../components/b122/editFields/MultiFileField.vue";
import AutoCompleteObjectField from "../../../components/b122/editFields/AutoCompleteObjectField.vue";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";

export default {

  name: "AddFactureModal",

  components: {
    AutoCompleteObjectField,
    MultiFileField,
    AutocompleteField,
    DatepickerInput
  },

  props: {
    operationConstructionName: "",
    operationConstruction: {
      type: Object,
      default: null
    },
    statusFactureList: null
  },

  data() {
    let cancelVariant = 'danger'
    let cancelTitle = 'Cancel'
    let okTitle = 'Add'
    let facture = this.operationConstruction.facture
    if (facture) {
      okTitle = 'Modify'
    }
    return {
      cancelVariant: cancelVariant,
      cancelTitle: cancelTitle,
      okTitle: okTitle,
      nom: null,
      prixTTC: null,
      tauxTVA: null,
      status: null,
      issuedDate: null,
      paidDate: null,
      compte: null,
      libelle: null,
      documents: null,
      contacts: [],
      newDocumentsList: [],
      oldDocumentsList: [],
      documentsToRemove: []
    }
  },

  emits: ['didAddFacture'],

  async mounted() {
    await this.fetchData()
  },

  watch: {
    operationConstruction: {
      deep: true,
      handler(newVal) {
        this.initializeValues();
      },
    },
  },


  methods: {


    async fetchData() {
      this.initializeValues()
    },

    initializeValues() {
      let facture = this.operationConstruction.facture
      if (facture) {
        this.nom = facture.nom
        this.prixTTC = facture.prixTTC
        this.tauxTVA = facture.tauxTVA
        this.status = facture.status
        this.issuedDate = facture.issuedDate
        this.paidDate = facture.paidDate
        this.documents = facture.documents
        this.libelle = facture.libelle
        this.oldDocumentsList = facture.documents
      } else {
        this.resetModal()
        this.hideModal()
      }
    },


    handleAddAndValidate(bvModalEvent) {
      this.resetModal()
      this.hideModal()
    },

    handleAdd(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },

    handleSubmit() {
      if (this.prixTTC && this.nom) {
        let operationFacture = this.operationConstruction.facture
        if (operationFacture) {
          operationFacture.nom = this.nom
          operationFacture.prixTTC = this.prixTTC
          operationFacture.tauxTVA = this.tauxTVA
          operationFacture.status = this.status
          operationFacture.issuedDate = this.issuedDate
          operationFacture.paidDate = this.paidDate
          operationFacture.documents = this.newDocumentsList.concat(this.oldDocumentsList);
          operationFacture.libelle = this.libelle
          this.operationConstruction.facture = operationFacture
        } else {
          operationFacture = {
            nom: this.nom,
            prixTTC: this.prixTTC,
            tauxTVA: this.tauxTVA,
            status: this.status,
            libelle: this.libelle,
            issuedDate: this.issuedDate,
            paidDate: this.paidDate,
            documents: this.newDocumentsList,
          }
          this.operationConstruction.facture = operationFacture
        }
        this.operationConstruction.lastModifDate = Date.now()
        this.$emit('didAddFacture', this.operationConstruction)
        this.resetModal()
        this.hideModal()
      }
    },

    resetModal() {
      this.nom = null
      this.prixTTC = null
      this.tauxTVA = null
      this.status = null
      this.paidDate = null
      this.libelle = null
      this.issuedDate = null
      this.newDocumentsList = []
      this.selectedDevisIndex = null
    },

    hideModal() {
      this.$bvModal.hide('add-facture-modal')
    },

    addDocuments(files) {
      files.forEach(file => {
        if (file) {
          this.newDocumentsList.push(file)
        }
      })
    },

    removeNewDocument(file) {
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
    },

    removeOldDocument(fileToRemove) {
      this.newDocumentsList = this.newDocumentsList.filter(file => file.id !== fileToRemove.id);

      this.oldDocumentsList = this.oldDocumentsList.filter(file => file.id !== fileToRemove.id);

      this.documents = this.documents.filter(file => file.id !== fileToRemove.id);

      if (fileToRemove.id) {
        api.delete(`/operationDevis/deleteFileDevis/${file.id}`)
      }
    },
  }


}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/AddFactureModal.vue